// ReactJS
import * as React from 'react';

// Material UI
import Grid from '@mui/material/Grid2';
import { Typography, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';

// Material UI Form
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputAdornment from '@mui/material/InputAdornment';

// Material UI Modal
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Icons UI
import CloseIcon from '@mui/icons-material/Close';

// Styles UI 
import { styled } from '@mui/material/styles';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function SetPassword(p) {
    // console.log(p);
    
    return (
        <div>
            {p.children && React.cloneElement(p.children, { onClick: p.handleOpen })}
            {!p.children && <Button variant='contained' color='ochre' onClick={p.handleOpen}>Edit pass</Button>}
            <BootstrapDialog
                maxWidth='sm'
                // style={{minWidth:"50vw !important"}}
                open={p.open}
                fullWidth={true}
                onClose={p.handleOpen}
            >
                <DialogTitle>Clave Unica Crypto Avanzada</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={p.handleOpen}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers className='barscroll pb-10'>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }}>
                            {/* <Grid size={{ xs: 4, sm: 10, md: 12 }} className="flex items-center">
                                <Typography color={""} className='ml-4'>Clave:</Typography>
                            </Grid> */}
                            <Grid size={{ xs: 4, sm: 10, md: 12 }} className="flex items-center">
                                <TextField
                                    fullWidth
                                    id="cuca"
                                    label="Escribe tu contraseña unica"
                                    variant="outlined"
                                    type='password'
                                    color={"ochre"}
                                    size="small"
                                value={p.pass}
                                onChange={(e)=>{p.setPass(e.target.value)}}
                                />
                            </Grid>
                        </Grid>
                    </form>

                </DialogContent>
                <DialogActions className='flex justify-end px-5'>
                    <div>
                        <Button className='mr-5' color='ochre' variant="contained" onClick={p.handleOpen}>Aceptar</Button>
                        {/* <Button color='error' variant="outlined" onClick={p.handleOpen}>Cancelar</Button> */}
                    </div>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}

export default SetPassword